import React, { useState, useCallback } from 'react';
import { createUseStyles } from 'react-jss';
import BackgroundImage from './BackgroundImage';
import { Article } from '../types';
import { Link } from 'react-router-dom';
export interface ArticleCardProps {
    article: Article;
    //   className?: string;
    //   trackName?: string;
}
const ArticleCard: React.FC<ArticleCardProps> = ({ article }) => {
    const classes = useStyles();

    return (
        <>
            <div className={classes.containerArticleCard}>
                <div className={classes.headerArticleCard}>
                    <BackgroundImage height="200px" src={article.cover} />
                    <p className={classes.date}>{article.createdAtAsString}</p>
                    <Link to={article.username} className={classes.title}>{article.title}</Link>
                </div>
                <div className={classes.footerArticleCard}>
                    <Link
                        to={article.username}
                        className={classes.readMore}
                    >Read More</Link>
                </div>
            </div>
        </>
    )
};

const useStyles = createUseStyles({
    containerArticleCard: {
        boxShadow: 'rgb(0 0 0 / 18%) 0px 2px 4px',
        width: '100%',
        borderRadius: '15px',
        padding: '5px',
        height: '400px',
    },
    headerArticleCard: {
        display: 'flex',
        justifyContent: 'spaceEvenly',
        flexDirection: 'column',
    },
    date: {
        margin: '10px 5px',
        color: '#636e72',
    },
    title: {
        margin: '10px 5px',
        fontWeight: '600',
        fontSize: '1.25rem',
        color: '#000',
        "&:hover": {
            color: '#000',
        },
    },
    footerArticleCard: {
        cursor: 'pointer',
        color: '#fff',
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: '1.5em',
    },
    readMore:
    {
        background: '#522583',
        borderRadius: '18px',
        padding: '5px',
        width: '125px',
        textAlign: 'center',
        fontWeight: '600px',
        color: '#fff',
        "&:hover": {
            color: '#fff',
        },
    },
});

export default ArticleCard;
